export const routes=[
    {
      newUrl:"/product/krunch-burger",
      oldUrl:"KrunchBurger_3",
      combo: false
    },
    {
      newUrl:"/product/rice-n-spice",
      oldUrl:"Rice&Spice_4",
      combo: false
    },
    {
    newUrl: "/product/zingeratha",
    oldUrl: "Zingeratha_5",
    combo: false
  },
  {
    newUrl: "/product/krunch-burger+drink",
    oldUrl: "KrunchBurger+Drink_6",
    combo: false
  },
  {
    newUrl: "/product/krunch-combo",
    oldUrl: "KrunchCombo_5",
    combo: true
  },
  {
    newUrl: "/product/chicken-chips",
    oldUrl: "Chicken&Chips_4",
    combo: false
  },
  {
    newUrl: "/product/krunch-chicken-combo",
    oldUrl: "KrunchChickenCombo_7",
    combo: true
  },
  {
    newUrl: "/product/3-pcs-chicken",
    oldUrl: "3PcsChicken_1",
    combo: false
  },
  {
    newUrl: "/product/twister",
    oldUrl: "Twister_9",
    combo: false
  },
  {
    newUrl: "/product/zinger-burger",
    oldUrl: "ZingerBurger_6",
    combo: false
  },
  {
    newUrl: "/product/kentucky-burger",
    oldUrl: "KentuckyBurger_7",
    combo: false
  },
    {
    newUrl: "/product/zinger-stacker",
    oldUrl: "ZingerStacker_10",
    combo: false
  },
  {
    newUrl: "/product/twister-combo",
    oldUrl: "TwisterCombo_11",
    combo: true
  },
  {
    newUrl: "/product/mighty-zinger",
    oldUrl: "MightyZinger_8",
    combo: false
  },
  {
    newUrl: "/product/zinger-combo",
    oldUrl: "ZingerCombo_8",
    combo: true
  },
  {
    newUrl: "/product/kentucky-combo",
    oldUrl: "KentuckyBurgerCombo_9",
    combo: true
  },
  {
    newUrl: "/product/zinger-stacker-combo",
    oldUrl: "ZingerStackerCombo_12",
    combo: true
  },
  {
    newUrl: "/product/mighty-zinger-combo",
    oldUrl: "MightyZingerCombo_10",
    combo: true
  },
  {
    newUrl: "/product/crispy-box",
    oldUrl: "CrispyBox_16",
    combo: true
  },
  {
    newUrl: "/product/boneless-meal-box",
    oldUrl: "BonelessBox_17",
    combo: true
  },
  {
    newUrl: "/product/wow-meal-box",
    oldUrl: "WowBox_14",
    combo: true
  },
  {
    newUrl: "/product/crispy-duo-box",
    oldUrl: "CrispyDuoBox_15",
    combo: true
  },
  {
    newUrl: "/product/xtreme-duo-box",
    oldUrl: "XtremeDuoBox_13",
    combo: true
  },
  {
    newUrl: "/product/value-bucket",
    oldUrl: "ValueBucket_21",
    combo: true
  },
{
    newUrl: "/product/family-festival-2",
    oldUrl: "FamilyFestival2_19",
    combo: true
  },
  {
    newUrl: "/product/family-festival-3",
    oldUrl: "FamilyFestival3_20",
    combo: true
  },
    {
    newUrl: "/product/1-pc-chicken",
    oldUrl: "OnePieceChicken_20",
    combo: false
  },
  {
    newUrl: "/product/regular-fries",
    oldUrl: "Fries_18",
    combo: false
  },
  {
    newUrl: "/product/large-fries",
    oldUrl: "Fries_18",
    combo: false
  },
  {
    newUrl: "/product/hotshots",
    oldUrl: "HotShots_17",
    combo: false
  },
  {
    newUrl: "/product/fries-bucket",
    oldUrl: "FriesBucket_19",
    combo: false
  },
  {
    newUrl: "/product/6-pc-spicy-nuggets",
    oldUrl: "SpicyNuggets_11",
    combo: false
  },
  {
    newUrl: "/product/buffalo-wings",
    oldUrl: "BuffaloWings_14",
    combo: false
  },
  {
    newUrl: "/product/tangy-masala-wings",
    oldUrl: "TangyMasalaWings_13",
    combo: false
  },
  {
    newUrl: "/product/thai-sweet-chilli-wings",
    oldUrl: "ThaiSweetChilliWings_15",
    combo: false
  },
  {
    newUrl: "/product/chicky-meal-without-toy",
    oldUrl: "ChickyMeal1withoutToy_34",
    combo: false
  },
    {
    newUrl: "/product/chicky-meal--with-slice-without-toy",
    oldUrl: "ChickyMeal1withoutToy_33",
    combo: false
  },
  {
    newUrl: "/product/snack-bucket",
    oldUrl: "SnackBucket_22",
    combo: true
  },
  {
    newUrl: "/product/hot-wings",
    oldUrl: "HotWingsBucket_16",
    combo: false
  },
  {
    newUrl: "/product/9-pcs-nuggets",
    oldUrl: "PlainNuggets_12",
    combo: false
  },
  {
    newUrl: "/product/dinner-roll",
    oldUrl: "DinnerRoll_29",
    combo: false
  },
  {
    newUrl: "/product/9-pc-spicy-nuggets",
    oldUrl: "SpicyNuggets_11",
    combo: false
  },
  {
    newUrl: "/product/coleslaw",
    oldUrl: "Coleslaw_21",
    combo: false
  },
  {
    newUrl: "/product/corn-on-the-cob",
    oldUrl: "CornOnTheCob_22",
    combo: false
  },
  {
    newUrl: "/product/1.5-ltr-drink",
    oldUrl: "1.5LtrDrink_25",
    combo: false
  },
  {
    newUrl: "/product/mineral-water-500ml",
    oldUrl: "MineralWater500ml_23",
    combo: false
  },
  {
    newUrl: "/product/mirinda-regular",
    oldUrl: "MirindaRegular_27",
    combo: false
  },
  {
    newUrl: "/product/mountain-dew-regular",
    oldUrl: "MountainDewRegular_28",
    combo: false
  },
  {
    newUrl: "/product/pepsi-regular",
    oldUrl: "PepsiRegular_24",
    combo: false
  },
  {
    newUrl: "/product/chicky-meal-1-with-toy",
    oldUrl: "ChickyMeal1withToy_30",
    combo: false
  },
    {
    newUrl: "/product/chicky-meal-1-with-slice-and-toy",
    oldUrl: "ChickyMeal1withToy_35",
    combo: false
  },
  {
    newUrl: "/product/chicky-meal-2-with-toy",
    oldUrl: "ChickyMeal2WithToy_36",
    combo: false
  },
  {
    newUrl: "/product/chicky-meal-2-with-slice-and-toy",
    oldUrl: "ChickyMeal2WithToy_37",
    combo: false
  },
  {
    newUrl: "/product/fries-bucket-with-mayo-dip",
    oldUrl: "FriesBucket_19",
    combo: false
  },
  {
    newUrl: "/product/fries-bucket-with-vietnamese-dip",
    oldUrl: "FriesBucket_19",
    combo: false
  },
  {
    newUrl: "/product/6-pcs-nuggets",
    oldUrl: "PlainNuggets_12",
    combo: false
  },
  {
    newUrl: "/product/salsa-sprinkle-wings-bucket",
    oldUrl: "SalsaSprinkleWingsBucket_38",
    combo: false
  },
  {
    newUrl: "/product/chicky-meal-1-with-slice-without-toy",
    oldUrl: "ChickyMeal1withoutToy_33",
    combo: false
  },
  {
    newUrl: "/product/chicky-meal-1-without-toy",
    oldUrl: "ChickyMeal1withoutToy_34",
    combo: false
  },
  {
    newUrl: "/product/7up-diet",
    oldUrl: "7UPRegular_26",
    combo: false
  },
  {
    newUrl: "/product/midnight-deal-1",
    oldUrl: "MidnightDeal1_1",
    combo: true
  },
  {
    newUrl: "/product/midnight-deal-2",
    oldUrl: "MidnightDeal2_2",
    combo: true
  },
  {
    newUrl: "/product/midnight-deal-3",
    oldUrl: "MidnightDeal3_3",
    combo: true
  },
  {
    newUrl: "/product/krunch-burger-+-drink",
    oldUrl: "KrunchBurger+Drink_6",
    combo: true
  },
  {
    newUrl: "/product/krunch-with-fries-n-drink",
    oldUrl: "KrunchCombo_5",
    combo: true
  },
  {
    newUrl: "/product/chicken-n-chips",
    oldUrl: "Chicken&Chips_4",
    combo: true
  },
  {
    newUrl: "/product/family-festival-1",
    oldUrl: "FamilyFestival1_18",
    combo: true
  }

]